var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallRedirectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M11 5.222V6H4.778v13.223H18V13h.778v7H4V5.222h7zM20 4v7h-.778V5.327L13.75 10.8l-.55-.55 5.472-5.473H13V4h7z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Crect width='24' height='24'/%3E %3Cpath fill='%23646464' d='M10.9999998,5.22222222 L10.9999998,6 L4.77777762,6 L4.77777778,19.223 L17.9999998,19.2222222 L18,13 L18.7777778,13 L18.7777778,20 L3.99999984,20 L3.99999984,5.22222222 L10.9999998,5.22222222 Z M19.9999999,4 L19.9999999,11 L19.2222222,11 L19.2219999,5.327 L13.7501402,10.7998316 L13.2001683,10.2498597 L18.6719999,4.777 L12.9999999,4.77777778 L12.9999999,4 L19.9999999,4 Z'/%3E %3C/g%3E %3C/svg%3E";
export { SvgSmallRedirectIcon as ReactComponent };